import { GetProps, isWeb, SizableText, Stack, styled } from '@mythical/ui'
import React from 'react'

// TODO: This most likely is outdated, check the usage and just update the variants if it's not

const TagWrapper = styled(Stack, {
  px: '$2',
  br: '$1',
  variants: {
    variant: {
      primary: {
        bg: '$brandPurple',
      },
      neutral: {
        bg: 'rgba(0, 0, 0, 0.4)',
      },
      secondary: {
        bg: '$bgTertiary',
      },
      green: {
        bg: '$fgSuccess',
      },
      teal: {
        bg: '$brandTeal',
      },
      mustard: {
        bg: '$brandMustard',
      },
      white: {
        bg: '$white',
      },
    },
    displaySize: {
      xs: {
        px: '$2',
        h: 20,
        br: 100,
        ai: 'center',
        jc: 'center',
      },
      sm: {
        px: '$2',
        h: 20,
        br: 100,
        ai: 'center',
        jc: 'center',
      },
      md: {
        px: '$3',
        h: 24,
        br: 100,
        ai: 'center',
        jc: 'center',
      },
      lg: {
        px: '$3',
        h: 36,
        br: 100,
        ai: 'center',
        jc: 'center',
      },
      xl: {
        px: '$4',
        h: 44,
        br: 100,
        ai: 'center',
        jc: 'center',
      },
    },
  } as const,
  defaultVariants: {
    variant: 'primary',
    displaySize: 'sm',
  },
})

const TagText = styled(SizableText, {
  textAlign: 'center',
  position: 'relative',
  fontFamily: '$body',
  textDecorationLine: 'none',
  ...(isWeb && { pos: 'relative', top: '-2.5%' }),
  variants: {
    variant: {
      primary: {
        color: '$white',
      },
      neutral: {
        color: '$fgPrimary',
      },
      secondary: {
        color: '$white',
      },
      green: {
        color: '$white',
      },
      mustard: {
        color: '$fgInverted',
      },
      teal: {
        color: '$white',
      },
      white: {
        color: '$fgInverted',
      },
    },
    displaySize: {
      xs: {
        fontSize: 7,
        fontWeight: '550',
        lineHeight: '140%',
      },
      sm: {
        size: '$1',
      },
      md: {
        size: '$2',
      },
      lg: {
        size: '$3',
      },
      xl: {
        size: '$4',
      },
    },
    uppercase: {
      true: {
        textTransform: 'uppercase',
      },
      false: {
        textTransform: 'none',
      },
    },
  } as const,
  defaultVariants: {
    displaySize: 'sm',
    uppercase: true,
  },
})

type CustomTagProps = GetProps<typeof TagWrapper>
type CustomTagTextProps = GetProps<typeof TagText>

type TagProps = {
  children: React.ReactNode
  textProps?: CustomTagTextProps
}

export type ITagProps = TagProps & CustomTagProps & CustomTagTextProps

export const Tag = React.forwardRef<HTMLDivElement, ITagProps>(
  ({ children, textProps, uppercase, displaySize, variant, ...props }, ref) => {
    const commonProps = {
      displaySize,
      variant,
    }

    return (
      <TagWrapper ref={ref} {...commonProps} {...props}>
        <TagText uppercase={uppercase} {...commonProps} {...textProps}>
          {children}
        </TagText>
      </TagWrapper>
    )
  },
)
